import NTopNBottom from '../../components/NTopNBottom'
import calcRemFn from '../calcRem'

import bannerImg from '../../assets/ImageArt2022/banner.jpg'
import navColor from '../../assets/ImageArt2022/nav/color.jpg'
import navBg from '../../assets/ImageArt2022/nav/nav_bg.png'
import navBgFixed from '../../assets/ImageArt2022/nav/nav_bg_fix.png'

import far1 from '../../assets/ImageArt2022/nav/far1.png'
import far1_active from '../../assets/ImageArt2022/nav/far1_active.png'
import far2 from '../../assets/ImageArt2022/nav/far2.png'
import far2_active from '../../assets/ImageArt2022/nav/far2_active.png'

import son1 from '../../assets/ImageArt2022/nav/son1.png'
import son1_active from '../../assets/ImageArt2022/nav/son1_active.png'
import son2 from '../../assets/ImageArt2022/nav/son2.png'
import son2_active from '../../assets/ImageArt2022/nav/son2_active.png'
import son3 from '../../assets/ImageArt2022/nav/son3.png'
import son3_active from '../../assets/ImageArt2022/nav/son3_active.png'
import son4 from '../../assets/ImageArt2022/nav/son4.png'
import son4_active from '../../assets/ImageArt2022/nav/son4_active.png'
import son5 from '../../assets/ImageArt2022/nav/son5.png'
import son5_active from '../../assets/ImageArt2022/nav/son5_active.png'
import son6 from '../../assets/ImageArt2022/nav/son6.png'
import son6_active from '../../assets/ImageArt2022/nav/son6_active.png'
import son7 from '../../assets/ImageArt2022/nav/son7.png'
import son7_active from '../../assets/ImageArt2022/nav/son7_active.png'
import son8 from '../../assets/ImageArt2022/nav/son8.png'
import son8_active from '../../assets/ImageArt2022/nav/son8_active.png'


import p1_1_1 from '../../assets/ImageArt2022/ctn/1_1_1.jpg'
import p1_1_2 from '../../assets/ImageArt2022/ctn/1_1_2.jpg'
import p1_1_3 from '../../assets/ImageArt2022/ctn/1_1_3.jpg'
import p1_1_4 from '../../assets/ImageArt2022/ctn/1_1_4.jpg'

import p1_2_1 from '../../assets/ImageArt2022/ctn/1_2_1.jpg'
import p1_2_2 from '../../assets/ImageArt2022/ctn/1_2_2.jpg'

import p1_3_1 from '../../assets/ImageArt2022/ctn/1_3_1.jpg'
import p1_3_2 from '../../assets/ImageArt2022/ctn/1_3_2.jpg'

import p2_1_1 from '../../assets/ImageArt2022/ctn/2_1_1.jpg'
import p2_1_2 from '../../assets/ImageArt2022/ctn/2_1_2.jpg'
import p2_2_1 from '../../assets/ImageArt2022/ctn/2_2_1.jpg'
import p2_2_2 from '../../assets/ImageArt2022/ctn/2_2_2.jpg'
import p2_3_1 from '../../assets/ImageArt2022/ctn/2_3_1.jpg'
import p2_3_2 from '../../assets/ImageArt2022/ctn/2_3_2.jpg'
import p2_4_1 from '../../assets/ImageArt2022/ctn/2_4_1.jpg'
import p2_4_2 from '../../assets/ImageArt2022/ctn/2_4_2.jpg'
import p2_5_1 from '../../assets/ImageArt2022/ctn/2_5_1.jpg'
import p2_5_2 from '../../assets/ImageArt2022/ctn/2_5_2.jpg'

const IS_PROD = process.env.VUE_APP_ENV_MICRO === 'production'

// 需要手动修改proId
const top1_id = IS_PROD ? '97019' : '97019'
const top2_id = IS_PROD ? '110387' : '110387'

const navCss = {
  navWrap: {
    minHeight: calcRemFn(130),
    backgroundImage: `url(${navColor})`,
  },
  navCtn: {
    height: calcRemFn(130),
    backgroundImage: `url(${navBg})`,
  },
  navCtnFixed: {
    height: calcRemFn(130),
    backgroundImage: `url(${navBgFixed})`,
  },
  topBtnLayout: {
    marginTop: `${calcRemFn(13)}`,
    marginLeft: `${calcRemFn(18)}`,
    flexWrap: 'wrap',
  },
  topBtnBaseCss: {
    width: calcRemFn(36.5),
    height: calcRemFn(107),
  },
  bottomBtnBaseCss: {
    marginTop: `${calcRemFn(15)}`,
  }
}

const navData = {
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
      img: far1,
      img_actived: far1_active,
    },
    {
      key: 'top2',
      show: true,
      img: far2,
      img_actived: far2_active,
    },
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: true,
        prodId: top1_id,
        img: son1,
        img_actived: son1_active
      },
      {
        key: '_i2',
        show: true,
        prodId: top1_id,
        img: son2,
        img_actived: son2_active
      },
      {
        key: '_i3',
        show: true,
        prodId: top1_id,
        img: son3,
        img_actived: son3_active
      },
    ],
    top2: [
      {
        key: '_i1',
        show: true,
        prodId: top2_id,
        img: son4,
        img_actived: son4_active
      },
      {
        key: '_i2',
        show: true,
        prodId: top2_id,
        img: son5,
        img_actived: son5_active
      },
      {
        key: '_i3',
        show: true,
        prodId: top2_id,
        img: son6,
        img_actived: son6_active
      },
      {
        key: '_i4',
        show: true,
        prodId: top2_id,
        img: son7,
        img_actived: son7_active
      },
      {
        key: '_i5',
        show: true,
        prodId: top2_id,
        img: son8,
        img_actived: son8_active
      },
    ]
  }
}

const pictures = [
  {
    type: 'blue',
  },
  {
    id: top1_id,
    type: 'blue',
    ref: 'top1_i1',
    farName: 'top1',
    sonName: '_i1',
    son: [
      p1_1_1,
      p1_1_2,
      p1_1_3,
      p1_1_4,
    ],
    name: '探索-昼夜'
  },
  {
    id: top1_id,
    type: 'blue',
    ref: 'top1_i2',
    farName: 'top1',
    sonName: '_i2',
    son: [
      p1_2_1,
      p1_2_2,
    ],
    name: '探索-对话'
  },
  {
    id: top1_id,
    type: 'blue',
    ref: 'top1_i3',
    farName: 'top1',
    sonName: '_i3',
    son: [
      p1_3_1,
      p1_3_2,
    ],
    name: '探索-候场'
  },
  {
    id: top2_id,
    type: 'blue',
    ref: 'top2_i1',
    farName: 'top2',
    sonName: '_i1',
    son: [
      p2_1_1,
      p2_1_2,
    ],
    name: '情绪-清晰'
  },
  {
    id: top2_id,
    type: 'blue',
    ref: 'top2_i2',
    farName: 'top2',
    sonName: '_i2',
    son: [
      p2_2_1,
      p2_2_2
    ],
    name: '情绪-氧气'
  },
  {
    id: top2_id,
    type: 'blue',
    ref: 'top2_i3',
    farName: 'top2',
    sonName: '_i3',
    son: [
      p2_3_1,
      p2_3_2
    ],
    name: '情绪-质感'
  },
  {
    id: top2_id,
    type: 'blue',
    ref: 'top2_i4',
    farName: 'top2',
    sonName: '_i4',
    son: [
      p2_4_1,
      p2_4_2
    ],
    name: '情绪-深邃'
  },
  {
    id: top2_id,
    type: 'blue',
    ref: 'top2_i5',
    farName: 'top2',
    sonName: '_i5',
    son: [
      p2_5_1,
      p2_5_2
    ],
    name: '情绪-朦胧'
  }
]

const topDiff = {
  firstSon: '_i1',
  // top1_i1: 78,
  // top2_i1: 90,
}

export default {
  title: '影像空间',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff,
}
